package com.qrkontaq.ui.admin

object AdminStringsDe : AdminStrings {
    override val tabDashboard = "Überblick"
    override val tabDashboardSub = "Was heute in Ihrem Lokal passiert"
    override val tabMenu = "Menü"
    override val tabMenuSub = "Kategorien, Gerichte, Preise und die Stopp-Liste"
    override val tabStopList = "Stopp-Liste"
    override val tabStopListSub = "Gericht ausverkauft? Ein Tipp genügt"
    override val tabTables = "Tische"
    override val tabTablesSub = "Rufe aus dem Saal und QR-Codes zum Drucken"
    override val tabStaff = "Team"
    override val tabStaffSub = "Einladungen und Rollen der Mitarbeiter"
    override val tabSettings = "Einstellungen"
    override val tabSettingsSub = "Marke, Kontakte, Öffnungszeiten"
    override val tabSubscription = "Abo"
    override val tabSubscriptionSub = ""

    override val openSite = "Website öffnen"
    override val logout = "Abmelden"
    override val viewSite = "Website ansehen"
    override val roleOwner = "Inhaber"
    override val roleManager = "Manager"
    override val roleWaiter = "Kellner"
    override val roleCook = "Koch"
    override val roleBartender = "Barkeeper"
    override val roleStaff = "Mitarbeiter"

    override val interfaceLanguage = "Sprache des Dashboards"
    override val pastDueBanner = "Der bezahlte Zeitraum ist abgelaufen. Die Pro-Funktionen laufen noch einige Tage weiter."
    override val pay = "Bezahlen"
    override val statScans = "QR-Scans"
    override val periodToday = "Heute"
    override val periodWeek = "Woche"
    override val periodMonth = "Monat"
    override val periodYear = "Jahr"
    override val prevPeriod = "Vorheriger Zeitraum"
    override val nextPeriod = "Nächster Zeitraum"
    override val statVisits = "Besuche"
    override val statRevenue = "Umsatz"
    override val statRating = "Bewertung"
    override val statDishLikes = "Likes für Gerichte"
    override val statCookedOrders = "Bestellungen zubereitet"
    override val statCookedDishes = "Gerichte zubereitet"
    override val statDrinksMade = "Getränke zubereitet"
    override val statServedOrders = "Bestellungen angenommen"
    override val statServedDishes = "Artikel angenommen"
    override val statTablesServed = "Tische bedient"
    override val myDishesCooked = "Was Sie zubereitet haben"
    override val myDrinksMade = "Getränke, die Sie gemacht haben"
    override val myDishesServed = "Was Sie angenommen haben"
    override val myTablesTitle = "Tische"
    override val myTimelineTitle = "Zeitverlauf"
    override val myWorkEmpty = "Für diesen Zeitraum gibt es noch keine Daten"
    override val scansByDay = "Scan-Verlauf"
    override fun maxBadge(value: String) = "max. $value"
    override val peakHours = "Spitzenzeiten (Scans)"
    override val scansByTable = "Scans pro Tisch"
    override val withoutTable = "ohne Tisch"
    override fun tableN(label: String) = "Tisch $label"
    override val topDishes = "Lieblingsgerichte der Gäste"
    override val soldProducts = "Verkaufte Artikel"
    override val dashEmptyTables = "Noch keine Scans"
    override val dashEmptyTablesHint = "Drucken Sie die QR-Codes der Tische — hier erscheint die Statistik pro Tisch"
    override val dashEmptySales = "Noch keine Verkäufe"
    override val dashEmptySalesHint = "Sobald Gäste bestellen, erscheint hier der Umsatz pro Gericht"
    override val dashEmptyTop = "Noch keine Likes"
    override val dashEmptyTopHint = "Gäste können Gerichte im Menü liken — die beliebtesten erscheinen hier"
    override val dashEmptyCallsHint = "Keine Rufe in diesem Zeitraum"
    override val dashEmptyPeakHint = "Daten erscheinen nach den ersten QR-Scans"

    override val tabOrders = "Bestellungen"
    override val tabOrdersSub = "Küche und Saal: Gericht-Status in Echtzeit"
    override val statusNew = "Neu"
    override val statusCooking = "In Arbeit"
    override val statusReady = "Fertig"
    override val statusServed = "Serviert"
    override val takeOrder = "In Arbeit nehmen"
    override val markReady = "Fertig"
    override val markServed = "Serviert"
    override val newOrderTitle = "Neue Bestellung"
    override val addOrderBtn = "Bestellung hinzufügen"
    override val addDishesHint = "Fügen Sie Gerichte aus dem Menü hinzu"
    override val totalLabel = "Summe"
    override val markPaid = "Bezahlt"
    override val confirmPaid = "Als bezahlt markieren und den Tisch freigeben?"
    override val tableFree = "Frei"
    override val noActiveOrders = "Keine aktiven Bestellungen"
    override val ordersColumnEmpty = "Leer"
    override fun orderTakenBy(name: String) = "Angenommen von $name"
    override val orderOtherWaiter = "Bestellung eines anderen Kellners"
    override val closeMixedTableHint = "An diesem Tisch liegt die Bestellung eines anderen Kellners — schließen kann sie ein Manager"
    override val waitingWaiter = "Wartet auf den Kellner"
    override val closeLabel = "Schließen"
    override fun minutesShort(min: Long) = "$min Min."
    override fun agoShort(min: Long) = when {
        min < 60 -> "$min Min."
        min < 1440 -> "${min / 60} Std."
        else -> "${min / 1440} T."
    }
    override val orderStepBack = "Schritt zurück"
    override val authCabinet = "Das Dashboard Ihres Lokals"
    override val authRegisterSub = "Erstellen Sie ein Konto zum Anmelden"
    override val authShopName = "Name des Restaurants"
    override val authShopNamePh = "Café „Gemütlich“"
    override val authDomain = "Domain"
    override val authDomainPh = "gemuetlich"
    override val authPassword = "Passwort"
    override val authSignIn = "Anmelden"
    override val authCreateAccount = "Konto erstellen"
    override val authCreateShop = "Lokal erstellen"
    override val authWizardSub = "Letzter Schritt: Erstellen Sie Ihren Betrieb"
    override val authNoShop = "Noch kein Lokal? Registrieren"
    override val authHaveAccount = "Bereits registriert? Anmelden"
    override val authNoAccount = "Kein Konto? Registrieren"
    override val authOr = "oder"
    override val authBack = "Zurück"
    override val authContinueGoogle = "Weiter mit Google"
    override val authContinueApple = "Weiter mit Apple"
    override val authLoginFailed = "Falsche E-Mail oder falsches Passwort."
    override val authRegisterFailed = "Registrierung fehlgeschlagen. Prüfen Sie die Angaben."
    override val authErrEmailInvalid = "Geben Sie eine gültige E-Mail ein — z. B. you@example.com."
    override val authErrEmailTaken = "Diese E-Mail ist bereits registriert. Versuchen Sie, sich anzumelden."
    override val authErrDomainTaken = "Diese Website-Adresse ist vergeben — wählen Sie eine andere."
    override val authErrDomainRules =
        "Website-Adresse: 3–30 Zeichen, nur lateinische Buchstaben, Ziffern und Bindestriche; beginnt und endet mit einem Buchstaben oder einer Ziffer."
    override val authPasswordHint = "Mindestens 6 Zeichen"
    override val authErrPasswordRules =
        "Das Passwort ist zu kurz: mindestens 6 Zeichen erforderlich."
    override val authErrInvalidCredentials = "Falsche E-Mail oder falsches Passwort."
    override val authErrOauthAccount = "Dieses Konto meldet sich über Google/Apple an — nutzen Sie stattdessen diesen Button."
    override val authErrOauthEmailTaken = "Diese E-Mail ist bereits mit Passwort registriert – melden Sie sich mit E-Mail und Passwort an."
    override val authErrDeactivated = "Dieses Konto ist deaktiviert. Kontaktieren Sie den Support."
    override val authErrDomainReserved = "Diese Adresse ist vom System reserviert — wählen Sie eine andere."
    override val authErrNameRules = "Name des Lokals: 1 bis 100 Zeichen."
    override val brandTagline = "Ihre eigene Website in 1 Minute — und sofort einsatzbereit"
    override val brandFeature1 = "QR-Menü in mehreren Sprachen"
    override val brandFeature2 = "Saal und Küche in Echtzeit"
    override val brandFeature3 = "Statistiken, Stopp-Liste und Team"
    override val brandFeature4 = "Bestellungen, Rechnungen und Zahlung"
    override val brandFeature6 = "Gratis-Tarif, ohne Karte"
    override val inviteWelcome = "Dem Team beitreten"
    override val inviteAccepting = "Einladung wird angenommen…"
    override fun inviteJoined(role: String) = "Sie sind als $role beigetreten"
    override val inviteGoCabinet = "Zum Dashboard"
    override val inviteInvalid = "Die Einladung ist ungültig oder abgelaufen"
    override val inviteLoginHint = "Melden Sie sich an oder registrieren Sie sich, um die Einladung anzunehmen"
    override val hallCalls = "Rufe aus dem Saal"
    override val legendWaiter = "Kellner"
    override val legendBill = "Rechnung"
    override val asksBill = "bittet um die Rechnung"
    override val callsWaiter = "ruft einen Kellner"
    override val done = "Erledigt"
    override val markedDone = "Als erledigt markiert"
    override val callUpdateFailed = "Der Ruf konnte nicht aktualisiert werden"
    override val layoutSaveFailed = "Die Tisch-Anordnung konnte nicht gespeichert werden"
    override val bootFailed = "Keine Verbindung zum Server. Prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut."
    override val bootRetry = "Erneut versuchen"

    override fun inStop(count: Int) = "Im Stopp: $count"
    override fun totalDishes(count: Int) = "Gerichte gesamt: $count"
    override val searchDishPh = "Gericht suchen…"
    override val nothingFound = "Nichts gefunden"
    override val tryAnotherQuery = "Versuchen Sie eine andere Suche"
    override val outOfStock = "nicht verfügbar"
    override fun backInMenu(name: String) = "„$name“ ist wieder im Menü"
    override val putToStop = "Auf die Stopp-Liste gesetzt"
    override val updateFailed = "Aktualisierung fehlgeschlagen"

    override val addTableTitle = "Tisch hinzufügen"
    override val tableLabelPh = "Z. B. 5 oder Terrasse 2"
    override val add = "Hinzufügen"
    override val addTableFailed = "Der Tisch konnte nicht hinzugefügt werden"
    override fun tablesCount(count: Int) = "Tische ($count)"
    override val qrPdf = "QR als PDF"
    override val preparingPdf = "PDF wird erstellt…"
    override fun deleteTable(label: String) = "Tisch $label löschen"
    override fun deleteTableConfirm(label: String) = "Tisch $label löschen?"
    override val planHint = "Ziehen Sie die Tische, um sie wie im Saal anzuordnen. Die Anordnung wird in diesem Browser gespeichert."
    override val noTablesTitle = "Noch keine Tische"
    override val noTablesHint = "Fügen Sie Tische hinzu — wir erstellen ein druckfertiges PDF mit QR-Codes"

    override val inviteTitle = "Mitarbeiter einladen"
    override val inviteHint = "Kellner — Tische und Bestellungen. Koch — Bestellungen (Tische nur zur Ansicht). Manager — alles außer dem Abo."
    override val createInvite = "Einladung erstellen"
    override val inviteCreated = "Einladung erstellt"
    override val inviteCreateFailed = "Die Einladung konnte nicht erstellt werden"
    override val copy = "Kopieren"
    override val copied = "Kopiert"
    override fun teamCount(count: Int) = "Team ($count)"
    override val removeFromTeam = "Aus dem Team entfernen"
    override val removeFromTeamConfirm = "Aus dem Team entfernen?"
    override val activeInvites = "Aktive Einladungen:"
    override fun validUntil(date: String) = "gültig bis $date"
    override val cancel = "Abbrechen"
    override val teamMembersWord = "Mitglieder"
    override fun teamMemberSince(date: String) = "im Team seit $date"
    override val permWaiter = "Tische und Bestellungen"
    override val permCook = "Bestellungen für die Küche"
    override val permBartender = "Bestellungen für die Bar"
    override val permManager = "Alles außer dem Abo"
    override val barCategory = "Bar-Kategorie (Getränke)"
    override val barBadge = "Bar"

    override val currentState = "Aktueller Status"
    override fun activeUntil(date: String) = "Aktiv bis $date"
    override val pastDueLong = "Zahlung überfällig — die Pro-Funktionen werden bald pausiert"
    override val badgeActive = "Aktiv"
    override val badgePastDue = "Überfällig"
    override val plan1Month = "1 Monat"
    override val plan3Months = "3 Monate"
    override val plan12Months = "12 Monate"
    override val bestValueBadge = "-17% · am günstigsten"
    override val payMono = "Auswählen"
    override val autoRenewLabel = "Automatische Verlängerung"
    override val autoRenewHint = "Ihre Karte wird nach der Zahlung gespeichert, und das Abo verlängert sich automatisch. Sie können das jederzeit abschalten."
    override val autoRenewActive = { mask: String? ->
        "Automatische Verlängerung ist aktiviert" + (mask?.let { " · Karte •••• $it" } ?: "")
    }
    override val autoRenewDisable = "Abschalten"
    override val planActiveTitle = "Plan aktiv"
    override val nextChargeOn = { date: String, amount: String -> "Nächste Abbuchung $date · $amount" }
    override val autoRenewOffNote = { date: String -> "Automatische Verlängerung ist aus — der Zugang gilt bis $date" }
    override val cancelSubscription = "Abo kündigen"
    override val resumeAutoRenew = "Verlängerung wieder aktivieren"
    override val subActiveOverline = "Abo aktiv"
    override val subEyebrow = "Tarife"
    override val subChooseTitle = "Free oder Pro"
    override val subChooseSub = "Menü, Bestellungen und Tische — für immer kostenlos. Pro schaltet Gäste-Services und das Team frei."
    override val subFeaturesCap = "In Pro enthalten"
    override val subFeatures = listOf(
        "Treueprogramm mit Cashback",
        "Kellner-Ruf-Taste",
        "Tischrechnung für Gäste",
        "Menü in mehreren Sprachen",
        "Bereiche „Beliebt“ und „Chef empfiehlt“",
        "Team und Personal-Einladungen",
    )
    override val subCtaSubscribe = "Auf Pro upgraden"
    override val trustCancel = "Jederzeit kündbar"
    override val trustSecure = "Sichere Zahlung"

    override val planFree = "Free"
    override val planPro = "Pro"
    override val planFreeSub = "Menü ohne Limits"
    override val planCurrent = "Ihr Tarif"
    override val planRecommended = "Empfohlen"
    override val perMonth = "pro Monat"
    override val proLockTitle = "Verfügbar mit Pro"
    override val proLockTeamBody = "Laden Sie Kellner, Köche und Manager im Pro-Tarif ein. Aktuelle Teammitglieder bleiben."
    override val proUpgradeCta = "Auf Pro upgraden"
    override val proSectionHint = "Verfügbar im Pro-Tarif — aktivieren Sie ihn im Tab „Abo“."
    override val proLangHint = "Bei Free ist eine Menüsprache aktiv — jederzeit wechselbar. Pro schaltet alle Sprachen frei."
    override val payHint = "Zahlung über die sichere Seite von monobank. Nach der Zahlung verlängert sich das Abo automatisch."
    override val paymentHistory = "Zahlungsverlauf"

    override val newCategory = "Neue Kategorie"
    override val addCategory = "Kategorie hinzufügen"
    override val hiddenBadge = "ausgeblendet"
    override val showLabel = "Anzeigen"
    override val hideLabel = "Ausblenden"
    override val moreActions = "Weitere Aktionen"
    override val moveUp = "Nach oben"
    override val moveDown = "Nach unten"
    override val deleteCategory = "Kategorie löschen"
    override fun deleteCategoryConfirm(name: String) = "Kategorie „$name“ samt Gerichten löschen?"
    override val addDishPlus = "＋ Gericht hinzufügen"
    override val copySuffix = " (Kopie)"
    override val duplicate = "Duplizieren"
    override val dishDuplicated = "Gericht dupliziert"
    override val duplicateFailed = "Duplizieren fehlgeschlagen"
    override val edit = "Bearbeiten"
    override val delete = "Löschen"
    override fun deleteDishConfirm(name: String) = "„$name“ löschen?"
    override val dishDeleted = "Gericht gelöscht"
    override val deleteFailed = "Löschen fehlgeschlagen"
    override val dangerZoneTitle = "Gefahrenzone"
    override val dangerZoneHint =
        "Das Löschen des Lokals ist endgültig: Menü, Fotos, Tische, Bestellungen, Team, Treueprogramm und die Website-Adresse verschwinden."
    override val deleteVenueButton = "Lokal löschen"
    override val deleteVenueModalTitle = "Dieses Lokal löschen?"
    override val deleteVenueModalBody =
        "Diese Aktion kann nicht rückgängig gemacht werden. Dauerhaft gelöscht werden: Menü und Fotos, Tische und QR-Codes, " +
            "Bestellungen und Statistiken, Team und Einladungen, das Treueprogramm und die Website-Adresse."
    override fun deleteVenueConfirmLabel(name: String) = "Geben Sie zur Bestätigung den Namen „$name“ ein"
    override val deleteVenueConfirmPlaceholder = "Name des Lokals"
    override val deleteVenueConfirmCta = "Endgültig löschen"
    override val deleteVenueSuccess = "Lokal gelöscht"
    override val stopBadge = "Stopp"
    override val descriptionLabel = "Beschreibung"
    override val descriptionPh = "Z. B.: Tomaten, Mozzarella, frisches Basilikum"
    override val priceLabel = "Preis"
    override val weightLabel = "Gewicht/Volumen"
    override val weightPh = "320 g"
    override val kcalLabel = "Kcal"
    override val tagsLabel = "Tags"
    override val allergensLabel = "Allergene"
    override val tagVegan = "Vegan"
    override val tagSpicy = "Scharf"
    override val tagNew = "Neu"
    override val allergenGluten = "Gluten"
    override val allergenLactose = "Laktose"
    override val allergenNuts = "Nüsse"
    override val allergenEggs = "Eier"
    override val allergenFish = "Fisch"
    override val allergenSoy = "Soja"
    override val chefRecommends = "Chef empfiehlt"
    override val uploadingEllipsis = "Wird hochgeladen…"
    override val addPhoto = "Foto hinzufügen"
    override val replacePhoto = "Foto ersetzen"
    override val photoUploadFailed = "Das Foto konnte nicht hochgeladen werden"
    override val addDish = "Gericht hinzufügen"
    override val save = "Speichern"
    override val dishAdded = "Gericht hinzugefügt"
    override val savedToast = "Gespeichert"
    override val saveFailed = "Speichern fehlgeschlagen"
    override val menuStatCategories = "Kategorien"
    override val menuStatDishes = "Gerichte"
    override val menuStatFeatured = "Hits"
    override val menuEmptyTitle = "Das Menü ist noch leer"
    override val menuEmptyHint = "Erstellen Sie die erste Kategorie — und fügen Sie dann Gerichte hinzu."
    override val categoryLabel = "Kategorie"
    override val editCategory = "Kategorie bearbeiten"
    override val editDish = "Gericht bearbeiten"
    override val noCategory = "Ohne Kategorie"

    override val sitePreviewTitle = "So wird die Website aussehen"
    override val sitePreviewHint = "Die Vorschau aktualisiert sich sofort — speichern Sie, um es auf die Website zu übernehmen."
    override val restaurantNamePh = "Name des Restaurants"
    override val brandTitle = "Marke"
    override val logoLabel = "Logo"
    override val coverLabel = "Cover"
    override val nameLabel = "Name"
    override val shortDescription = "Kurzbeschreibung"
    override val accentHint = "Akzentfarbe — Buttons, Preise und Hervorhebungen auf Ihrer Website"
    override val customColorLabel = "Oder eigene Farbe"
    override val contactsTitle = "Kontakte"
    override val addressLabel = "Adresse"
    override val mapPickHint = "Verschieben Sie die Karte, bis der Pin auf Ihr Lokal zeigt"
    override val mapFindByAddress = "Nach Adresse suchen"
    override val mapUseLocation = "Mein Standort"
    override val phoneLabel = "Telefon"
    override val socialsHint = "Soziale Netzwerke — Gäste sehen sie im Bereich „Über uns“ auf der Website"
    override val workingHoursTitle = "Öffnungszeiten"
    override val workingHoursHint = "Leer = Ruhetag. Format 09:00 / 22:00, auch über Mitternacht möglich (18:00–02:00)."
    override val dayMon = "Mo"
    override val dayTue = "Di"
    override val dayWed = "Mi"
    override val dayThu = "Do"
    override val dayFri = "Fr"
    override val daySat = "Sa"
    override val daySun = "So"
    override val dayOff = "Ruhetag"
    override val siteThemeTitle = "Website-Theme"
    override val siteThemeHint = "So sieht das Menü für Gäste aus: hell, dunkel oder automatisch nach den Handy-Einstellungen."
    override val themeAuto = "Auto (wie beim Gast)"
    override val themeLight = "Hell"
    override val themeDark = "Dunkel"
    override val menuLookTitle = "Menü-Darstellung"
    override val categoryPhotosTitle = "Fotos in den Kategorien"
    override val categoryPhotosHint = "Der Kategorie-Chip zeigt das Foto des ersten Gerichts; ohne Foto — nur Text"
    override val featureFirstTitle = "Erstes Gericht als große Karte"
    override val featureFirstHint = "Das erste Gericht der Kategorie bekommt ein Foto in voller Breite; ausgeschaltet — wie alle anderen"
    override val showPopularTitle = "Bereich „Beliebt“"
    override val showPopularHint = "Eine Auswahl beliebter Gerichte oben im Menü anzeigen"
    override val showChefTitle = "Bereich „Chef empfiehlt“"
    override val showChefHint = "Eine Auswahl der vom Chef empfohlenen Gerichte anzeigen"
    override val showFiltersTitle = "Filter-Button"
    override val showFiltersHint = "Den Filter-Button neben den Menü-Kategorien anzeigen"
    override val menuLanguagesTitle = "Menüsprachen"
    override val menuLanguagesHint = "Gäste können diese Sprachen auf der Website umschalten. Füllen Sie Namen und Beschreibungen in den gewählten Sprachen aus."
    override val saveChanges = "Änderungen speichern"
    override val savedCheck = "Gespeichert ✓"
    override val savedSiteUpdated = "Gespeichert — die Website ist aktualisiert"
    override val saveFailedCheckColor = "Speichern fehlgeschlagen (prüfen Sie die Farbe #RRGGBB)"
    override val upload = "Hochladen"
    override val replace = "Ersetzen"

    override val currencyTitle = "Währung"
    override val currencyHint = "Währung der Menüpreise und der Bonuspunkte der Gäste."
    override val guestServicesTitle = "Services am Tisch"
    override val guestServicesHint = "Was der Gast nach dem QR-Scan auf der Tischseite sieht"
    override val guestCheckTitle = "Rechnung für Gäste anzeigen"
    override val guestCheckHint = "Gäste sehen ihre Rechnung in Echtzeit: Positionen, Menge und Summe"
    override val waiterCallTitle = "Kellnerruf"
    override val waiterCallHint = "Gäste können einen Kellner rufen oder die Rechnung verlangen"
    override val loyaltyTitle = "Treueprogramm"
    override val loyaltyEnableTitle = "Cashback für Gäste"
    override val loyaltyEnableHint = "Gäste sammeln mit jeder Rechnung Bonuspunkte und lösen sie beim Bezahlen ein"
    override val loyaltyRateLabel = "Cashback-Prozentsatz der Rechnung (1–50)"
    override val loyaltyRateHint = "Dieser Anteil der Rechnungssumme kommt als Bonuspunkte an den Gast zurück"
    override val loyaltyGuestTitle = "Bonuspunkte des Gastes"
    override val loyaltyCandidatesTitle = "Haben diesen Tisch kürzlich gescannt"
    override val loyaltyCodePh = "6-stelliger Code"
    override val loyaltyScanQr = "QR scannen"
    override val loyaltyFindGuest = "Gast finden"
    override val loyaltyCodeNotFound = "Code nicht gefunden"
    override val loyaltyCodeExpired = "Code abgelaufen — bitten Sie den Gast, einen neuen zu zeigen"
    override val loyaltyCheckFailed = "Der Code konnte nicht geprüft werden"
    override val loyaltyBalanceLabel = "Guthaben"
    override val loyaltyRedeemLabel = "Punkte einlösen"
    override val loyaltyEarnedLabel = "Gutgeschrieben"
    override val loyaltyRedeemedLabel = "Eingelöst"
    override val loyaltyNewBalanceLabel = "Neues Guthaben"
    override val loyaltyClear = "Zurücksetzen"
    override val loyaltyCameraFailed = "Kamera nicht verfügbar — geben Sie den Code manuell ein"
    override val loyaltyGuestAtTable = "Gast am Tisch"
    override val loyaltyNewGuest = "Neuer Gast"
    override val loyaltyVisitsSuffix = "Besuche"
    override val loyaltyCallingWaiter = "Ruft einen Kellner"
    override val loyaltyCallingBill = "Bittet um die Rechnung"
}
